import React, { useState } from 'react';
import api from '../api/api'; 
import { useNavigate, Link } from 'react-router-dom';
import logoCafe from '../assets/logoCafeBlancoB.png';

const COLOR_SIERRA_GREEN = '#2E5B2E'; 
const COLOR_CANTERA_PINK = '#C19A6B';
const COLOR_WHITE = '#FFFFFF';
const COLOR_CHARCOAL = '#333333';

function LoginMobile({ onLoginSuccess }) {
    const navigate = useNavigate();
    // 1. CAMBIO: De 'email' a 'identifier' para aceptar usuarios sin arroba
    const [identifier, setIdentifier] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            // 2. CAMBIO: Enviamos la llave 'identifier' que espera el Back V2
            const response = await api.post('/auth/login', { identifier, password });
            const { accessToken, user } = response.data;

            if (!accessToken) {
                setError('No se recibió token válido');
                return;
            }

            localStorage.setItem('token', accessToken);
            
            // Guardamos el usuario/rol si el back lo manda, útil para lógica futura
            if(user) {
                localStorage.setItem('user_role', user.rol);
            }

            if (onLoginSuccess) onLoginSuccess(accessToken);

            if (user && user.rol === 'Admin') {
                navigate('/admin');
            } else {
                // Tanto Dueños como Empleados van a bienvenida (el dashboard decidirá qué mostrar)
                navigate('/bienvenida');
            }

        } catch (err) {
            console.error(err);
            // Mensaje más genérico por seguridad
            setError('Credenciales incorrectas o cuenta inactiva');
        }
    };
    
    // --- ESTILOS MÓVIL (Mismos estilos, sin cambios) ---
    const PAGE_CONTAINER = { 
        minHeight: '100vh', 
        background: COLOR_SIERRA_GREEN, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'flex-start', 
        padding: '20px 0',
        position: 'relative',
        overflow: 'hidden'
    };
    
    const navBarButtonStyle = { 
        background: 'transparent', 
        color: COLOR_WHITE, 
        padding: '8px 15px', 
        borderRadius: 20, 
        border: `1px solid ${COLOR_WHITE}50`, 
        fontWeight: 'bold',
        cursor: 'pointer',
        textDecoration: 'none',
        fontSize: 14
    };
    
    const formCardStyle = { 
        width: '90%', 
        maxWidth: 400,
        background: COLOR_WHITE, 
        borderRadius: 16, 
        padding: 30, 
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        zIndex: 10,
        color: COLOR_CHARCOAL
    };
    
    const inputStyle = { 
        width: '100%', 
        padding: 12, 
        marginBottom: 20, 
        borderRadius: 5, 
        background: COLOR_WHITE, 
        fontSize: 16, 
        border: `1px solid ${COLOR_CANTERA_PINK}`,
        color: COLOR_CHARCOAL,
    };
    
    const submitButtonStyle = { 
        width: '100%', 
        background: COLOR_SIERRA_GREEN, 
        color: COLOR_WHITE, 
        padding: 15, 
        borderRadius: 8, 
        fontWeight: 'bold', 
        fontSize: 18, 
        border: 'none', 
        marginBottom: 15,
        cursor: 'pointer',
    };
    
    const secondaryButtonStyle = { 
        width: '100%', 
        background: 'transparent', 
        color: COLOR_CANTERA_PINK, 
        padding: 10, 
        borderRadius: 8, 
        fontSize: 14, 
        border: `1px solid ${COLOR_CANTERA_PINK}`, 
        cursor: 'pointer',
    };

    const labelStyle = { 
        marginBottom: 5, 
        display: 'block', 
        fontWeight: 'bold', 
        color: COLOR_CHARCOAL,
        fontSize: 14 
    };

    return (
        <div style={PAGE_CONTAINER}>
            <div style={{ width: '90%', maxWidth: 400, display: 'flex', justifyContent: 'flex-end', alignItems:'center', marginBottom: 20, zIndex: 10 }}>
                <Link to="/contacto" style={{...navBarButtonStyle, marginRight: 10}}>Contactar</Link>
                <Link to="/" style={{...navBarButtonStyle, background: COLOR_CANTERA_PINK, border:'none'}}>Inicio</Link> 
            </div>
            
            <div style={formCardStyle}>
                <div>
                    <img src={logoCafe} alt="Xavana Logo" style={{height: 120, marginBottom: 15}} />
                    <div style={{color: COLOR_SIERRA_GREEN, fontSize: 20, fontWeight: 'bold', textAlign: 'center', marginBottom: 20}}>Bienvenido</div>
                </div>
                <form style={{ width: '100%' }} onSubmit={handleSubmit}>
                    {/* 3. CAMBIO: Label actualizado */}
                    <label style={labelStyle}>Usuario o Email</label>
                    {/* 4. CAMBIO: Input type text y value identifier */}
                    <input 
                        type="text" 
                        value={identifier} 
                        onChange={e => setIdentifier(e.target.value)} 
                        style={inputStyle} 
                        required 
                        placeholder="ej. juan@cafe.com o barista1"
                    />
                    
                    <label style={labelStyle}>Contraseña</label>
                    <input type="password" value={password} onChange={e => setPassword(e.target.value)} style={inputStyle} required />
                    
                    <button type="submit" style={submitButtonStyle}>Ingresar</button>
                    
                    {error && <div style={{ color: '#ef4444', textAlign: 'center', marginBottom: 15, fontSize: 14 }}>{error}</div>}
                </form>
                <button style={secondaryButtonStyle}>Olvidé mi contraseña</button>
            </div>
        </div>
    );
}

export default LoginMobile;